/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mw-config-switch.vue?vue&type=template&id=3ad56058&scoped=true&"
import script from "./mw-config-switch.vue?vue&type=script&lang=js&"
export * from "./mw-config-switch.vue?vue&type=script&lang=js&"
import style0 from "./mw-config-switch.vue?vue&type=style&index=0&id=3ad56058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad56058",
  null
  
)

export default component.exports